<template>

  <font-awesome-layers fixed-width>
    <font-awesome-icon icon="laptop" :size="size" transform="shrink-1 left-4"></font-awesome-icon>
    <font-awesome-icon icon="info" :size="size" transform="shrink-10 right-3 up-2 left-4"></font-awesome-icon>
    <font-awesome-icon icon="mobile" :size="size" inverse transform="shrink-3 right-12 down-3 left-4"></font-awesome-icon>
    <font-awesome-icon icon="mobile-alt" :size="size" transform="shrink-3 right-12 down-3 left-4"></font-awesome-icon>
  </font-awesome-layers>

</template>

<script>
export default {
  name: 'icon-asset',
  props: [ 'size' ]
}
</script>

<style scoped lang="scss">

</style>
